module.exports = __webpack_public_path__ + "img/dhaly.26743d9a.gif";